import { formatName } from "@api";
import type { IFupBeneficiary } from "@bbj-types/socialApply/fup";
import { Divider, Stack, type Theme, Typography, useMediaQuery } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { LabelInfo } from "@styleguide";

interface IVisualizeBeneficiaryAdminProps {
  beneficiary: IFupBeneficiary;
}

export const VisualizeBeneficiaryAdmin = ({ beneficiary }: IVisualizeBeneficiaryAdminProps) => {
  const { timeZone } = useI18nContext();
  const tablet = useMediaQuery((theme: Theme) => theme.breakpoints.up("tablet"));

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="h4" color="primary">
        Bénéficiaire : informations administratives
      </Typography>
      <Stack
        direction={tablet ? "row" : "column"}
        sx={{
          flex: 1,
          gap: 2,
        }}
      >
        <Stack
          sx={{
            flex: 1,
          }}
        >
          <LabelInfo
            label="Prénom, Nom"
            text={`${!beneficiary.gender ? null : beneficiary.gender === "F" ? "Madame" : "Monsieur"} ${formatName(beneficiary)}`}
          />
          <LabelInfo
            label="Date de naissance"
            text={beneficiary?.birthDate?.toLocaleDateString("fr-FR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              timeZone,
            })}
          />
          <LabelInfo
            label="Adresse"
            text={
              beneficiary.address?.formatted
                ? `${beneficiary.address.formatted} (${beneficiary.address?.isQPV ? "QPV" : "Non QPV"})`
                : ""
            }
            noWrap
          />
          <LabelInfo label="N° de téléphone" text={formatPhoneNumber(beneficiary.phone)} />
          <LabelInfo label="Email" text={beneficiary.email} hidden={!beneficiary.email} />
        </Stack>
        {tablet && <Divider orientation="vertical" flexItem />}
        <Stack
          sx={{
            flex: 1,
          }}
        >
          <LabelInfo label="N° de sécurité sociale" text={beneficiary.socialSecurityNumber} />
          <LabelInfo label="N° CAF / MSA" text={beneficiary.cafNumber} />
          <LabelInfo label="Identifiant France Travail" text={beneficiary.poleEmploiNumber} />
        </Stack>
      </Stack>
    </Stack>
  );
};
